import { combineReducers, createStore, compose } from "redux";
import app from "./app";
import filter from "./filter";
import alert from "./alert";
import betslip from "./betslip";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const reducers = combineReducers({
  app,
  filter,
  alert,
  betslip,
});

const store = createStore(reducers, composeEnhancers());
/* eslint no-underscore-dangle: 0 */
export default store;

export type RootState = ReturnType<typeof store.getState>;
